export function formatDate(date) {
    return date.substring(8, 10) + '/' + date.substring(5, 7) + '/' + date.substring(0, 4);
}

export function returnDate(date) {
    if (date == null)
        return null;
    let qualDate = new Date(parseInt(date.substring(0, 4)), parseInt(date.substring(5, 7))-1, parseInt(date.substring(8, 10)));
    return qualDate;
}